import { TextField, Typography } from "@mui/material";
import React from "react";
import { useTreeModifyContext } from "./TreeDataContext";
import { usePathContext } from "./PathInfo";

interface TextComponentParams {
  value: string | number;
  propName: string | null;
  dontRenderPropName?: boolean;
}

export function TextComponent(props: TextComponentParams) {
  const { saveChangesAtPath } = useTreeModifyContext();
  const { path } = usePathContext();

  function performSave(newValue: any) {
    saveChangesAtPath(newValue, path);
  }

  const [currentValue, setCurrentValue] = React.useState(props.value);
  return (
    <>
      {!props.dontRenderPropName && <Typography component={"span"}>{props.propName}: </Typography>}
      <TextField
        size="small"
        fullWidth={true}
        value={currentValue}
        onBlur={(event) => {
          performSave(currentValue);
        }}
        onChange={(event) => {
          setCurrentValue(event.target.value);
        }}
      />
    </>
  );
}
